// extracted by mini-css-extract-plugin
export default {"root":"CloseButton-root-53b8bc8ad85371044a1aef680511c6a8","icon":"CloseButton-icon-c16f94afe5d42bfbc0261cc59d117bcd"};